module.exports = __webpack_public_path__ + "static/media/francebleu.1140dc7f.png";